import { CompactUserResponse } from '../account';
import { GraphGroupId } from '../graphGroup';
import { CompanyId } from '../companies';
import { EquationGraphFormData } from 'app/modules/statistics/graphs/AddEditGraphModal/GraphForm';
import { GroupId } from '../group';

export type GraphId = string;
export type GraphValueId = string;
export type GraphNoteId = string;
export type GraphDailyQuotaId = string;

export interface GraphResponse {
  id: GraphId;
  companyName?: string;
  title: string;
  description: string;
  position: string;
  assignee: CompactUserResponse;
  type: GraphType;
  menuOrder: number;
  kind: GraphKind;
  stat: GraphStats;
  statValue: string;
  isViability: boolean;
  viabilityLine: string;
  isUpsideDown: boolean;
  isOverlayUpsideDown: boolean;
  scaling: GraphScalingType;
  scalingTop: number;
  scalingBottom: number;
  days: DaysOfOperation;
  values: GraphValueResponse[];
  notes?: GraphNoteResponse[];
  //   groupId: GraphGroupId;
  groupId: GraphGroupId[];
  equation: string;
  equationGraphs: EquationGraphFormData[];
  graphKindCompanyId: string;
  valueNotes?: {
    [key: string]: string[];
  };
  isQuota: boolean;
  quota: number;
  quotaValues: GraphValueResponse[];
  quotaWeekly: GraphValueResponse[];
  quotaGraphValue: boolean;
  overlayValues: GraphValueResponse[];
  archive: number;
  overlayType: GraphOverlayType;
  graphCombinationCompanyId: CompanyId;
  firstGraphId: GraphId;
  firstGraphOffset: number;
  firstGraphName: string;
  secondGraphId: GraphId;
  secondGraphOffset: number;
  secondGraphName: string;
  beforeGraph?: GraphResponse;
  afterGraph?: GraphResponse;
}

export interface CompactGraphResponse {
  id: GraphId;
  name: string;
  title: string;
  menuOrder: number;
}

export interface GraphBoardType {
  columns: CompactGraphResponse[];
}

export interface GraphValueResponse {
  ending: any;
  id: GraphValueId;
  value: number;
  date: number;
  user: CompactUserResponse;
  dateUnix: number;
  overlayValue?: number;
  overlayDate?: number;
  overlayDateUnix?: number;
}

export interface GraphDailyQuotaResponse {
  id: GraphDailyQuotaId;
  graphId: GraphId;
  week: number;
  year: number;
  quota: number;
  isQuota: boolean;
}

export interface GraphNoteResponse {
  id: GraphNoteId;
  date: number;
  user: CompactUserResponse;
  note: string;
  createdAt: number;
}

export enum GraphType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
}

export enum GraphKind {
  regular = 'regular',
  equation = 'equation',
  combination = 'combination',
}

export enum GraphStats {
  currency = 'currency',
  percentage = 'percentage',
  numeric = 'numeric',
}

export enum GraphScalingType {
  auto = 'auto',
  custom = 'custom',
}

export enum GraphScalingOption {
  match = 'match',
  maintain = 'maintain',
}

export type DaysOfOperation = { [key in Day]: boolean };

export enum Day {
  mon = 'mon',
  tue = 'tue',
  wed = 'wed',
  thu = 'thu',
  fri = 'fri',
  sat = 'sat',
  sun = 'sun',
}

export enum OrientationGraph {
  portrait = 'portrait',
  landscape = 'landscape',
}

export enum GraphOverlayType {
  overlayOffset = 'overlayOffset',
  overlayDateRange = 'overlayDateRange',
}

export interface GraphRequestParams {
  groupId?: GraphGroupId;
  graphId?: GraphId;
  companyId?: CompanyId;
  date?: string;
  search?: string | string[];
  graphType?: string;
  offset?: number;
}

export interface EquationGraphResponse {
  title: string;
  companyId: CompanyId;
  graphId: GraphId;
  offset: number;
}

export interface GraphPageQuery {
  date?: string;
  search?: string;
  groupId?: GraphGroupId;
  graphId?: GraphId;
  graphType?: GraphType;
}

export interface GraphOverlayQuery {
  graphId?: GraphId;
  groupId?: GroupId;
  isFiltered: string;
  date?: string;
  offset?: number;
  startDate?: string;
  endDate?: string;
}

export interface GraphPdfQuery {
  graphId?: GraphId;
  group?: GroupId;
  perPage?: string;
  companyId?: CompanyId;
  orientation: OrientationGraph;
  viabilityLine: number;
  offset?: number;
}

export interface GraphSortQuery {
  graphs?: GraphResponse[] | CompactGraphResponse[];
  oldIndex?: number;
  newIndex?: number;
}
